import React from 'react';
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";

const NotFoundPage = () => {
    const { t } = useI18n();

    return (
        <Box sx={{ maxWidth: "600px", margin: "0 auto", padding: "120px 4%", textAlign: "center" }}>
            <Helmet>
                <title>404 | {t("brand.name")}</title>
            </Helmet>
            <Typography variant="display2" color="primary.main" gutterBottom>404</Typography>
            <Typography variant="h3" gutterBottom>{t("notFoundPage.title")}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                {t("notFoundPage.description")}
            </Typography>
            <Button variant="contained" component={RouterLink} to={t("links.home")}>
                {t("notFoundPage.cta")}
            </Button>
        </Box>
    );
};

export default NotFoundPage;
